export default __webpack_public_path__ + "media/images/icon-facebook-8b1afa726efe28d2716127a5de150c4b.svg";